import { useDispatch } from "react-redux"
import PostAddIcon from '@material-ui/icons/PostAdd';
import { IconButton, Tooltip } from "@material-ui/core"
import { openExtraVueloAction } from "../../../ducks/proveedorAereolineaDuck"

const BExtraVuelo = (props) => {
    const { vuelo } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openExtraVueloAction({
           vuelo
        }))
    }

    return (
        <Tooltip title="Extras">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <PostAddIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BExtraVuelo;